import React, { FC, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks/useStores';
import { useParams } from 'react-router-dom';
import capitalize from 'lodash/capitalize';

import isEmpty from 'lodash/isEmpty';
import Button from 'ati-ui-react/components/Button';
import Link from 'ati-ui-react/components/Link';
import getEnvironDomain from 'utils/getEnvironDomain';
import cn from 'classnames';

import { verificationPageLink } from 'constants/links';
import CheckCardList from '../CheckCardList';
import ResultsCheckVin from '../ResultsCheckVin';

import { typeText, ITexts } from './interface';

import {
  CheckTransportContainer,
  Header,
  Description,
  CheckTitle,
  HR,
  LinkContainer,
  ExplainDescription,
  DescriptionContainer,
  ButtonContainer,
} from './CheckTransportStyles';

const texts: Record<typeText, ITexts> = {
  sale: {
    owner: 'продавец',
    beforeAction: 'покупкой',
    action: 'приобрести',
  },
  rent: {
    owner: 'арендодатель',
    beforeAction: 'арендой',
    action: 'арендовать',
  },
};

const CheckTransport: FC = observer(() => {
  // @ts-ignore
  const { advType } = useParams();

  const {
    checksStore: {
      transportShortReport,
      isAdvertItemVin,
      isAdvertItemGovNum,
      isAdvertItemsMainVin,
      isAdvertItemsMainGovNum,
      checksStatus,
      getChecks,
      checks,
    },
    popupStore: { openLoginPopup },
    advertsStore: {
      currentAccount,
      currentAdvert,
      // @ts-ignore
      currentAdvert: { comment, contacts, is_owner, _id },
    },
    profileStore: { isUser },
  } = useStores();

  useEffect(() => {
    getChecks(_id);
  }, []);

  // @ts-ignore
  const isRoadTrain = !!currentAdvert.advert_items;
  const isAdvertItemVinGovNum = isAdvertItemVin || isAdvertItemGovNum;
  const isAdvertItemsMainVinGovNum = isAdvertItemsMainVin || isAdvertItemsMainGovNum;
  const hasCheckingOptions = !!(isAdvertItemVinGovNum || isAdvertItemsMainVinGovNum);

  if (!hasCheckingOptions && is_owner) return null;

  const onHandleClickMessage = () => {
    if (isUser) {
      window.open(
        // @ts-ignore
        `//chat.${getEnvironDomain()}/dialogs/${currentAccount?.account_id}.${contacts[0]}`,
        '_blank',
      );
    } else {
      openLoginPopup();
    }
  };

  const renderLink = () => {
    return (
      <LinkContainer>
        <Link type="external" small target="_blank" href={verificationPageLink}>
          Все проверки и примеры результатов
        </Link>
      </LinkContainer>
    );
  };

  const renderDescription = (typeAd: typeText) => {
    if (!hasCheckingOptions) {
      return (
        <>
          <Description>
            {capitalize(texts[typeAd].owner)} не указал VIN и госномер
            {isRoadTrain && ' основного ТС'}. Перед {texts[typeAd].beforeAction} запросите эти
            данные у владельца и воспользуйтесь сервисом&nbsp;
            <Link
              type="external"
              href={verificationPageLink}
              className="check-link"
              target="_blank"
            >
              Проверки
            </Link>
          </Description>
          <Description>
            Проверки подробно покажут, есть ли информация о ДТП с участием ТС, информацию о залоге,
            штрафах или угоне, записи о пробеге и пр.
          </Description>
          <Description>
            Это существенно снизит риск {texts[typeAd].action} проблемное ТС и поможет проверить,
            насколько достоверные данные указал {texts[typeAd].owner} в объявлении.
          </Description>
        </>
      );
    }
    if (typeAd === 'sale') {
      return (
        <>
          <Description>
            Проверки подробно покажут, есть ли информация о ДТП с участием ТС, информация о залоге,
            штрафах или угоне, записи о пробеге и пр.
          </Description>
          <Description className="second-paragraph">
            Это существенно снизит риск приобрести проблемное ТС и поможет проверить, насколько
            достоверные данные указал продавец в объявлении.
          </Description>
        </>
      );
    }
    return <Description>Проверки снизят риск арендовать проблемную технику.</Description>;
  };

  const messageButton = (
    <ButtonContainer>
      <Button target="_blank" className="button" onClick={onHandleClickMessage}>
        Написать владельцу
      </Button>
    </ButtonContainer>
  );

  const getHeaderText = () => {
    if (hasCheckingOptions && !isEmpty(transportShortReport)) {
      return 'Другие проверки';
    }
    return `Проверьте ТС перед ${advType === 'sale' ? 'покупкой' : 'долговременной арендой'}`;
  };

  const containerClasses = cn({
    'no-comment': !comment,
    'not-checking-options': !hasCheckingOptions,
  });

  return (
    <CheckTransportContainer className={containerClasses}>
      <ResultsCheckVin />
      <Header>{getHeaderText()}</Header>
      <DescriptionContainer>{renderDescription(advType)}</DescriptionContainer>

      {isUser && hasCheckingOptions && !checksStatus.isFailure && !isEmpty(checks) && (
        <div className="check-list">
          <HR />
          <CheckTitle>
            <span>Доступные проверки</span>
            <ExplainDescription>1 ат. = 1 &#8381;</ExplainDescription>
          </CheckTitle>
          <CheckCardList />
        </div>
      )}
      {!hasCheckingOptions && messageButton}
      {renderLink()}
    </CheckTransportContainer>
  );
});

export default CheckTransport;
